import { AIAction, EnemyType, ItemType } from "../../defines/enums"
import {
  Attack,
  CombatConfig,
  DropItem,
  Position,
  RenderConfig,
} from "../../defines/types"
import { generateRandomNumber } from "../../utils/rng"
import { Entity } from "../entity"

export class Enemy extends Entity {
  public static ATTACK_RANGE: number = 1

  private _combat: CombatConfig
  private _experience: number
  private _drop?: DropItem[]

  protected _state: AIAction

  constructor(
    public type: EnemyType,
    experience: number,
    combat: CombatConfig,
    position: Position,
    render: RenderConfig,
    name: string,
    optic?: ItemType
  ) {
    super(position, true, render, name, optic)

    this.baseClass = "Enemy"

    this._combat = { ...combat }
    this._experience = experience
    this._state = AIAction.WAITING
  }

  get attack(): Attack {
    const hit = generateRandomNumber(
      this._combat.minAttack,
      this._combat.maxAttack
    )
    return { amount: hit, type: this.combat.attackType }
  }

  get combat(): CombatConfig {
    return this._combat
  }

  get drop(): DropItem[] | undefined {
    return this._drop
  }

  get experience(): number {
    return this._experience
  }

  isAlive(): boolean {
    return this.combat.essence > 0
  }

  takeHit(attack: number): number {
    let essenceLost: number = 0
    if (attack > this.combat.essenceDefense) {
      essenceLost = attack - this.combat.essenceDefense
      this.combat.essence -= essenceLost
    }

    return essenceLost
  }
}
